import { render, staticRenderFns } from "./OpVerifyFrameDialog.vue?vue&type=template&id=60febc4a&"
import script from "./OpVerifyFrameDialog.vue?vue&type=script&lang=js&"
export * from "./OpVerifyFrameDialog.vue?vue&type=script&lang=js&"
import style0 from "./OpVerifyFrameDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60febc4a')) {
      api.createRecord('60febc4a', component.options)
    } else {
      api.reload('60febc4a', component.options)
    }
    module.hot.accept("./OpVerifyFrameDialog.vue?vue&type=template&id=60febc4a&", function () {
      api.rerender('60febc4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/verify/OpVerifyFrameDialog.vue"
export default component.exports